import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "./homeslider.css";
import next from "../assets/next.png";
import past from "../assets/past.png";
import { useNavigate } from "react-router-dom";
import arrow from "../assets/bottomarrow.png";
import { Phone, ArrowRight } from "lucide-react";

const ContactInfoItem = ({ Icon, text }) => (
  <p className="flex items-center px-6 py-3 bg-[#2c3639] text-white font-medium rounded-lg shadow-lg hover:bg-[#a27b5c] transition-all duration-300 mt-3 mb-6 callbtnslider transform hover:scale-105">
    <p>
      <Icon className="h-5 w-5 mr-3" />
    </p>
    {text}
  </p>
);

const WhyChooseSlider = () => {
  const navigate = useNavigate();

  const services = [
    {
      id: "invisiblegrills",
      route: "/invisiblegrills",
      title: "Invisible Grills for Balconies and Windows",
      highlight: true,
    },
    {
      id: "baclonysafetynets",
      route: "/balconysafenets",
      title: "Balcony Safety Nets",
      highlight: true,
    },

    {
      id: "childernsafetynetsinbengaluru",
      route: "/childernsafetynets",
      title: "Children's Safety Nets",
      highlight: true,
    },
    {
      id: "industirialSafetynets",
      route: "/industrialsafetynets",
      title: "Industrial Safety Nets",
      highlight: true,
    },
    {
      id: "petssafetynets",
      route: "/petssafetynets",
      title: "Pet Safety Nets",
      highlight: true,
    },
    {
      id: "ductarianets",
      route: "/ducterianets",
      title: "Duct Area Nets",
      highlight: true,
    },
    {
      id: "monkeysafetynets",
      route: "/monkeysafetynets",
      title: "Monkey Safety Nets",
      highlight: true,
    },
    {
      id: "cricketpracticenets",
      route: "/cricketpracticenets",
      title: "Cricket Practice Nets",
      highlight: true,
    },
    {
      id: "birdspikes",
      route: "/birdspikes",
      title: "Bird Spikes",
      highlight: true,
    },
  ];

  return (
    <div className="min-h-[500px] relative">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        navigation={{
          nextEl: ".custom-swiper-button-next",
          prevEl: ".custom-swiper-button-prev",
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        effect="fade"
        speed={800}
        spaceBetween={0}
        loop={true}
        breakpoints={{
          768: { slidesPerView: 1 },
          0: { slidesPerView: 1 },
        }}
        className="shadow-2xl  overflow-hidden"
      >
        {services.map((service) => (
          <SwiperSlide
            key={service.id}
            className="min-h-[500px] sliderouter relative cursor-pointer"
            id={service.id}
            onClick={() => navigate(service.route)}
          >
            <div className="slide-content flex flex-col items-center justify-center text-center px-8">
              <div className="service-title-container relative inline-block mb-6">
                <h2 className="text-5xl font-bold mb-4 transition-all duration-300">
                  <span
                    className={`service-name relative inline-block ${
                      service.highlight ? "text-[#a27b5c]" : "text-white"
                    }`}
                  >
                    {service.title}
                    <span className="absolute bottom-0 left-0 w-full h-1 bg-[#a27b5c] transform scale-x-0 transition-transform duration-500 hover:scale-x-100"></span>
                  </span>
                  <span className="text-white"> in Bengaluru</span>
                </h2>
              </div>

              <img
                src={arrow}
                alt="ANS SAFETY NETS, safety nets in bengaluru"
                loading="lazy"
                className="bootomarrow animate-bounce h-10 w-10 my-4"
              />

              <ContactInfoItem
                Icon={Phone}
                text={
                  <a
                    href="tel:+917416116587"
                    className="hover:underline text-lg"
                  >
                    +91 7416116587
                  </a>
                }
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons with React Icons */}
      <div className="custom-swiper-button-prev absolute left-4 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer p-3 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/40 hover:scale-110 transition-all duration-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-arrow-left-icon lucide-arrow-left w-6 h-6"
        >
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
      </div>

      <div className="custom-swiper-button-next absolute right-4 top-1/2 transform -translate-y-1/2 z-10 cursor-pointer p-3 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/40 hover:scale-110 transition-all duration-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-arrow-right-icon lucide-arrow-right w-6 h-6"
        >
          <path d="M5 12h14" />
          <path d="m12 5 7 7-7 7" />
        </svg>
      </div>
    </div>
  );
};

export default WhyChooseSlider;
